/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { Container, FlexContainer, H2, Stack, Text } from "@carrotfertility/carotene"
import React, { useEffect, useState } from "react"
import { surveyOptions } from "../lib/SurveyConstants"
import { RadioButton } from "./RadioButton"
import { useIntl } from "react-intl"

export const GuideSurvey = ({
  title,
  text,
  questionIndex,
  onQuestionSelect
}: {
  title: string
  text: string
  questionIndex: number
  onQuestionSelect: (questionIndex: string, selectedOption: number) => void
}): JSX.Element => {
  const [selectedOption, setSelectedOption] = useState(null)
  const [answeredQuestions, setAnsweredQuestions] = useState({})
  const intl = useIntl()

  useEffect(() => {
    if (answeredQuestions[`Question${questionIndex}`]) {
      setSelectedOption(answeredQuestions[`Question${questionIndex}`])
    } else {
      setSelectedOption(null)
    }
  }, [questionIndex, answeredQuestions])

  const onInputChange = (e): void => {
    setSelectedOption(e.target.value)
    onQuestionSelect(`Question${questionIndex}`, e.target.value)
    setAnsweredQuestions((prevState) => ({ ...prevState, [`Question${questionIndex}`]: e.target.value }))
  }
  return (
    <FlexContainer gap="large" direction="column" width={["100%"]}>
      <Stack>
        <H2>{title} </H2>
        <Container>
          <Text>{text}</Text>
          <FlexContainer
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            wrap="wrap"
            paddingTopBottom="giant"
            id={`Question${questionIndex}-survey-options`}
          >
            {questionIndex > 0 &&
              surveyOptions.map(({ value }, id) => {
                const surveySelectionButtonLabel = intl.formatMessage(surveyOptions[id].label)
                return (
                  <Container key={value} padding="0px 8px 24px 0px">
                    <RadioButton
                      value={surveyOptions[id].value}
                      checked={surveyOptions[id].value === selectedOption}
                      onChange={onInputChange}
                      className={`Question${questionIndex}-survey-option-button-${surveyOptions[id].value}`}
                    >
                      {surveySelectionButtonLabel}
                    </RadioButton>
                  </Container>
                )
              })}
          </FlexContainer>
        </Container>
      </Stack>
    </FlexContainer>
  )
}
